import type { Locale } from "~ui/utils/locales"

export const useLocales = () => {
  const { hasFeature } = useAuth()

  return computed<Locale[]>(() => {
    const baseLocales: Locale[] = ["da_DK", "en_US", "pl_PL", "nl_NL"]
    return hasFeature("admin:beta")
      ? [...baseLocales, "nb_NO", "sv_SE"]
      : baseLocales
  })
}
